import { type FC } from 'react';

import { GenericMenuList, type GenericMenuListProps } from '@craft/ui/components/lists';
import { Divider } from '@craft/ui/components/structural';
import { mergeSx } from '@craft/ui/util';

import { type CompetencyTagsData } from '../../types';

import { CompetencyTagGroup } from './CompetencyTagGroup';

export interface CompetencyTaggingListProps extends Omit<
  GenericMenuListProps,
  'autoFocusItem' | 'children'
> {
  readonly competencyTagsData: CompetencyTagsData;
  readonly onTagToggle: (tagId: string) => void;
  readonly selectedTagIds: string[];
}

export const CompetencyTaggingList: FC<CompetencyTaggingListProps> = ({
  competencyTagsData: { competencyTagGroups, ungroupedCompetencyTags },
  onTagToggle,
  selectedTagIds,
  sx,
  ...props
}) => (
  <GenericMenuList
    aria-label='competency tag selections'
    {...props}
    autoFocusItem
    sx={mergeSx({ paddingTop: 0 }, sx)}
  >
    {competencyTagGroups.map(group => (
      <CompetencyTagGroup
        groupName={group.name}
        key={group.name}
        onTagClick={onTagToggle}
        selectedTags={selectedTagIds}
        tags={group.tags}
      />
    ))}
    {ungroupedCompetencyTags.length > 0 && <Divider component='li' />}
    <CompetencyTagGroup
      groupName='Ungrouped Tags'
      onTagClick={onTagToggle}
      selectedTags={selectedTagIds}
      tags={ungroupedCompetencyTags}
    />
  </GenericMenuList>
);
